export default __webpack_public_path__ + "static/TSD_Blog_Overview_Holiday_Shopping_Season-66a95af4aefc1c00c6675c148e509416.jpg";